import React from "react";
import { useNavigate } from "react-router-dom";
import style from "./Impressum.module.css";
import Footer from "@/layouts/footer/Footer";
import Icon from "@/ui/icon/Icon";

function Impressum() {
	const navigate = useNavigate();

	return (
		<>
			<header className={style.header}>
				<button
					className={style.backButton}
					onClick={() => navigate("/")}
					aria-label="Nazad na početnu"
				>
					<Icon icon="fa-arrow-left" />
					<span>Nazad na početnu</span>
				</button>
				<h1 className={style.title}>Impresum</h1>
			</header>
			<div className={style.container}>
				<div className={style.content}>
					<p className={style.heading}>Podaci o kompaniji:</p>

					<p>Pin d.o.o.</p>
					<p>Ismeta Alajbegovića Šerbe 3</p>
					<p>71000 Sarajevo</p>

					<p>Društvo je registrovano kod Općinskog suda u Sarajevu</p>
					<p>MBS: 65-01-0773-13</p>
					<p>ID: 4201923640002</p>
					<p>PDV: 201923640002</p>
					<p>Bankovni račun: Raiffeisen BANK 1610000136950043</p>
					<p>E-mail: mentoriosedu@gmail.com</p>
					<p>Web stranica: www.mentorios.com</p>
				</div>
			</div>
			<Footer />
		</>
	);
}

export default Impressum;
